import React from 'react';
import './OrderInfoItem.scss';
import FormattedPrice from '../../components/FormattedPrice';
import delivery_icon from '../../assets/img/icons/delivery_item_info.png';
import { withTranslation } from 'react-i18next';

const DeliveryInfoItem = ({ item, t }) => {
  return (
    <div className={ 'order-item-info delivery-item' }>
      <div className={ 'img-block' }>
        <img
          src={ delivery_icon }
          className="img-responsive"
          alt="iPos Web Delivery" />
      </div>
      <div className={ 'info-block' }>
        <div className={ 'parent-item-info' }>
          <div className={ 'item-info-block' }>
            <div className={ 'item-name' }>{item.menuItem.item_name}</div>
            <div className={ 'item-description' }>{item.menuItem.details_txt}</div>
          </div>

          <div className={ 'item-quantity-info-block' }>
            <div className={ 'item-quantity-info' }>x {item.orderItem.quantity}</div>
          </div>

          <div className={ 'item-price-block' }>
            <div className={ 'item-price' }>
              <FormattedPrice price={ item.orderItem.price } />
            </div>
          </div>
        </div>

      </div>
    </div>
  );
};

export default withTranslation()(DeliveryInfoItem);
